import { render } from "./DiscountCoupon.vue?vue&type=template&id=1543fcd9&scoped=true"
import script from "./DiscountCoupon.vue?vue&type=script&lang=js"
export * from "./DiscountCoupon.vue?vue&type=script&lang=js"

import "./DiscountCoupon.vue?vue&type=style&index=0&id=1543fcd9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1543fcd9"]])

export default __exports__